import { withTranslation } from 'react-i18next';
import { t } from "../../hooks/useAppTranslation";
import React from 'react';
import './LeftMenuStyle.scss';
import {NavLink, withRouter} from "react-router-dom";
import {connect} from 'react-redux';
import {CST_SSOSERVICE_UI_URL} from "../../ssoSettings";


class LeftMenu extends React.Component {
	state = {
		controlMenuOpen: false,
		controlMyMenuOpen: false,
		showPopup: false,
		redirectTarget: '',
		overlayShow: false,
		showOverlay: false
	};


	unfoldControlMenu = () => {
		if (!this.state.controlMenuOpen) {
			this.setState({
				controlMenuOpen: true,
				controlMyMenuOpen: false
			});
			this.props.isSubmenuOpened(true);
		} else {
			this.setState({
				controlMenuOpen: false
			});
			this.props.isSubmenuOpened(false);
		}
	};

	unfoldControlsMenu = () => {
		if (this.state.controlMenuOpen || this.state.controlMyMenuOpen) {
			this.setState({
				controlMenuOpen: false,
				controlMyMenuOpen: false
			});
			this.props.isSubmenuOpened(false);
		}
	};

	handleCloseControls = () => {
		this.setState({
			controlMenuOpen: false
		});
		this.props.isSubmenuOpened(false);
	};

	handleCloseMyControls = () => {
		this.setState({
			controlMyMenuOpen: false
		});
		this.props.isSubmenuOpened(false);
	};

	unfoldMyControlMenu = () => {
		if (!this.state.controlMyMenuOpen) {
			this.setState({
				controlMyMenuOpen: true,
				controlMenuOpen: false
			});
			this.props.isSubmenuOpened(true);
		} else {
			this.setState({
				controlMyMenuOpen: false
			});
			this.props.isSubmenuOpened(false);
		}
	};

	addClassHighlight = (currentPath, menu) => {
		let menuPath;
		let menuClass;
		menu === 'control_button' ? menuPath = '/controls/' : menuPath = '/my_contro';
		currentPath = currentPath.substring(0, 10);
		if (currentPath === menuPath) {
			menuClass = 'highlight'
		}
		return menuClass;

	};

	isActive = (location, match) => {

		return (location.includes(match)) ? 'highlight' : '';

	};

	printMyControlsMenu = () => {
		return <div className='submenu-overflow' onClick={this.unfoldControlsMenu}>
			<div id='my_controls_menu' style={{top: this.calcControlsMenuHeight('my_control_button')}} onClick={(e) => e.stopPropagation()}>
				<p className='menu-head'>Moje kontrole
					<button
						className='btn close-submenu-btn'
						onClick={this.handleCloseMyControls}
						type='button'
						autoFocus
					>
						<span className='sr-only'>Zamknij submenu</span>
						<img aria-hidden={true} alt='' src={require("../../Pics/close-window.png")} />
					</button>
				</p>
				<NavLink to='/my_controls/planned' activeClassName={'highlight'} onClick={(event) => this.checkIfEditWindow(event,'/my_controls/planned')}><i
					aria-hidden='true'
					className='v-icon material-icons theme--light v-list-text'>list</i><span>Planowane</span></NavLink>
				<NavLink to='/my_controls/active' activeClassName={'highlight'} onClick={(event) => this.checkIfEditWindow(event,'/my_controls/active')}><i
					aria-hidden='true'
					className='v-icon material-icons theme--light v-list-text'>list</i><span>W trakcie realizacji</span></NavLink>
				<NavLink to='/my_controls/done' activeClassName={'highlight'} onClick={(event) => this.checkIfEditWindow(event,'/my_controls/done')}><i
					aria-hidden='true'
					className='v-icon material-icons theme--light v-list-text'>list</i><span>Zrealizowane</span></NavLink>
			</div>;
		</div>

	};

	calcControlsMenuHeight(elementId) {
		const menuHeight = 200
		let windowHeight = window.innerHeight
		const element = document.getElementById(elementId)
		const clickElement = element.getBoundingClientRect().top + 20
		let height = clickElement

		while((height + menuHeight) > windowHeight) {
			height--
		}
		return height
	}

	printControlsMenu = () => {
		return <div className='submenu-overflow' onClick={this.unfoldControlsMenu}>
			<div id='controls_menu' style={{top: this.calcControlsMenuHeight('control_button')}} onClick={(e) => e.stopPropagation()}>
				<p className='menu-head'>Zarządzaj kontrolami
					<button
						className='btn close-submenu-btn'
						onClick={this.handleCloseControls}
						type='button'
						autoFocus
					>
						<span className='sr-only'>Zamknij submenu</span>
						<img aria-hidden={true} alt='' src={require("../../Pics/close-window.png")} />
					</button>
				</p>
				<NavLink to='/controls/planned' activeClassName={'highlight'} onClick={(event) => this.checkIfEditWindow(event,'/controls/planned')}><i
					aria-hidden='true'
					className='v-icon material-icons theme--light v-list-text'>list</i><span>Planowane</span></NavLink>
				<NavLink to='/controls/active' activeClassName={'highlight'} onClick={(event) => this.checkIfEditWindow(event,'/controls/active')}><i
					aria-hidden='true'
					className='v-icon material-icons theme--light v-list-text'>list</i><span>W trakcie realizacji</span></NavLink>
				<NavLink to='/controls/done' activeClassName={'highlight'} onClick={(event) => this.checkIfEditWindow(event,'/controls/done')}><i
					aria-hidden='true'
					className='v-icon material-icons theme--light v-list-text'>list</i><span>Zrealizowane</span></NavLink>
			</div>;
		</div>

	};

	timeOutControlsMenu = () => {
		setTimeout(
			function () {
				this.setState({controlMenuOpen: false});
			}.bind(this),
			5000
		);
	};

	timeOutMyControlsMenu = () => {
		setTimeout(
			function () {
				this.setState({controlMyMenuOpen: false});
			}.bind(this),
			5000
		);
	};

	handleLoggout = () => {
		localStorage.clear();
	};

	showRedirectPopUp = (target) => {
		this.setState({showPopup: true, redirectTarget: target, showOverlay: true})
	};


	checkIfEditWindow = (e, target) => {
		e.preventDefault();
		this.props.history.push(target);
		this.unfoldControlsMenu()
	};


	handleClosePopUp = () => {
		this.setState({
			showPopup: false,
			showOverlay: false
		});
	};

	render() {
		const {location} = this.props;
		const userRole = this.props.userData.user?.roleDetails?.role;
		const userLogged = this.props.userData.isLogged;
		return (
			<div id='left_menu' className="left-menu">

				{(userLogged) ? (
					<nav aria-labelledby="mainNav" className="main-nav-container__list">
						<h2 className="sr-only" id="mainNav">{t("g-main-navigation", { force: true })}</h2>
						<div><p></p>
							<NavLink target='_blank' to={{pathname: CST_SSOSERVICE_UI_URL}}><i aria-hidden='true'
											   className='v-icon material-icons theme--light v-list-text'>home</i><span>{t("g-application-selection", { force: true })}</span></NavLink>
							<hr aria-hidden='true' className='v-divider theme--light standard-background'/>
						</div>
						{userRole === 'SA' ?
							(<div><p>Bloki</p>
								<NavLink to='/search_block'
										 onClick={(event) => this.checkIfEditWindow(event, '/search_block')}
										 activeClassName={'highlight'}><i aria-hidden='true'
								                                                             className='v-icon material-icons theme--light v-list-text'>list</i><span>Zarządzaj blokami</span></NavLink>
								<NavLink to='/create_block' onClick={(event) => this.checkIfEditWindow(event,'/create_block')} activeClassName={'highlight'}><i aria-hidden='true'
								                                                             className='v-icon material-icons theme--light v-list-text'>playlist_add</i><span>Utwórz blok</span></NavLink>
								<hr aria-hidden='true' className='v-divider theme--light standard-background'/>
							</div>) : null}

						{(userRole === 'SA' || userRole === 'A') ?
							(<div>
								<p>Pytania</p>
								<NavLink to='/search_question' onClick={(event) => this.checkIfEditWindow(event,'/search_question')} activeClassName={'highlight'}><i aria-hidden='true'
								                                                                className='v-icon material-icons theme--light v-list-text'>list</i><span>Zarządzaj pytaniami</span></NavLink>
								<NavLink to='/create_question' onClick={(event) => this.checkIfEditWindow(event,'/create_question')} activeClassName={'highlight'}><i aria-hidden='true'
								                                                                className='v-icon material-icons theme--light v-list-text'>playlist_add</i><span>Utwórz pytanie</span></NavLink>
								<hr aria-hidden='true' className='v-divider theme--light standard-background'/>
							</div>) : null}

						{(userRole === 'SA' || userRole === 'A' || userRole === 'SK') ?
							(<div>
								<p>Listy</p>
								<NavLink to='/manage_lists' onClick={(event) => this.checkIfEditWindow(event,'/manage_lists')} activeClassName={'highlight'}><i aria-hidden='true'
								                                                             className='v-icon material-icons theme--light v-list-text'>list</i><span>Zarządzaj listami</span></NavLink>
								{
									(userRole === 'SA' || userRole === 'A') ?
										<NavLink to='/create_list' onClick={(event) => this.checkIfEditWindow(event,'/create_list')} activeClassName={'highlight'}><i aria-hidden='true'
								                                                            className='v-icon material-icons theme--light v-list-text'>playlist_add</i><span>Utwórz listę</span></NavLink>
										: null
								}
								
								<hr aria-hidden='true' className='v-divider theme--light standard-background'/>
							</div>) : null}

						{(userRole === 'K' || userRole === 'SA' || userRole === 'A' || userRole === 'SK') ?
							(<div><p>Kontrole</p>
								{(userRole === 'SA' || userRole === 'A' || userRole === 'SK') ?
									(<div>
										<button className={this.addClassHighlight(window.location.pathname, 'control_button')} id='control_button'
										        onClick={this.unfoldControlMenu}><i aria-hidden='true'
										                                            className='v-icon material-icons theme--light v-list-text'>list</i><span>Zarządzaj kontrolami</span>
										</button>
										{this.state.controlMenuOpen ? this.printControlsMenu() : null}
										<NavLink to='/create_control' onClick={(event) => this.checkIfEditWindow(event, '/create_control')} className="left-panel-button-link" activeClassName={'highlight'}><i aria-hidden='true' className='v-icon material-icons theme--light v-list-text'>playlist_add</i><span>Utwórz kontrolę</span></NavLink>
									</div>) : null}
								<button className={this.addClassHighlight(location.pathname, 'my_control_button')} id='my_control_button'
								        onClick={this.unfoldMyControlMenu}><i aria-hidden='true'
								                                              className='v-icon material-icons theme--light v-list-text'>list</i><span>Moje kontrole</span>
								</button>
								{this.state.controlMyMenuOpen ? this.printMyControlsMenu() : null}
								<NavLink to='/post_control' onClick={(event) => this.checkIfEditWindow(event,'/post_control')} activeClassName={'highlight'}><i aria-hidden='true'
								                                                             className='v-icon material-icons theme--light v-list-text'>list</i><span>Dokumenty pokontrolne</span></NavLink>
								<hr aria-hidden='true' className='v-divider theme--light standard-background'/>
							</div>) : null}

						{(userRole === 'K' || userRole === 'SA' || userRole === 'A' || userRole === 'SK') ?
							(<div><p>{t("g-registered-controls", { force: true })}</p>
								<NavLink exact to='/external_controls_list' onClick={(event) => this.checkIfEditWindow(event,'/external_controls_list')} activeClassName={'highlight'} className={this.isActive(window.location.pathname, '/external_controls_list/') || this.isActive(window.location.pathname, '/external_controls/') || this.isActive(window.location.pathname, '/external_control_detail/')}>
									<i aria-hidden='true'className='v-icon material-icons theme--light v-list-text'>list</i>
									<span>{t("g-review-controls", { force: true })}</span>
								</NavLink>
								<NavLink to='/external_control/create' onClick={(event) => this.checkIfEditWindow(event,'/external_control/create')} activeClassName={'highlight'} className={this.isActive(window.location.pathname, '/external_control/create')}>
									<i aria-hidden='true' className='v-icon material-icons theme--light v-list-text'>list</i>
									<span>{t("g-register-control", { force: true })}</span>
								</NavLink>
							</div>) : null}

						{(userRole === 'O') ?
							(<div><p>Kontrole</p>
								<NavLink to='/post_control' onClick={(event) => this.checkIfEditWindow(event,'/post_control')} activeClassName={'highlight'}><i aria-hidden='true'
								                                                             className='v-icon material-icons theme--light v-list-text'>list</i><span>Dokumenty pokontrolne</span></NavLink>
								<hr aria-hidden='true' className='v-divider theme--light standard-background'/>
								<p>{t("g-registered-controls", { force: true })}</p>
								<NavLink exact to='/external_controls_list' onClick={(event) => this.checkIfEditWindow(event,'/external_controls_list')} activeClassName={'highlight'} className={this.isActive(window.location.pathname, '/external_controls_list/') || this.isActive(window.location.pathname, '/external_controls/') || this.isActive(window.location.pathname, '/external_control_detail/')}>
									<i aria-hidden='true'className='v-icon material-icons theme--light v-list-text'>list</i>
									<span>{t("g-review-controls", { force: true })}</span>
								</NavLink>
							</div>) : null}

							<hr aria-hidden='true' className='v-divider theme--light standard-background'/>
							<NavLink to='/help' onClick={(event) => this.checkIfEditWindow(event, '/help')} className="left-panel-button-link" activeClassName={'highlight'}><span>{t("g-help", { force: true })}</span></NavLink>
					</nav>
				) : null}
				{/* {this.state.showPopup ?
				<span>
					<Draggable handle='#popUp' defaultPosition={{x: 350, y: -600}} position={null} grid={[25, 25]} scale={1}
							   onStart={this.handleStart} onDrag={this.handleDrag} onStop={this.handleClose}>
					<div id="left_menu_cancel_popup">
						<div id='popUp' className='react-draggable'>
							<div id='popUpHeader' className={'cancel'}>
								<img className='close_blocks_img' alt={this.props.title} src={require('../../Pics/close-window.png')}
								onClick={this.handleClosePopUp} draggable={false}/>
								<p className='white h4'>Ostrzeżenie</p>
							</div>
							<div id='popUpInnerContent'>
								<div id='popUpNotification'>
									<div className='new-line'>{PropertyBucket.getCancelMessage()}</div>
									<div id='group_popUp'>
										<Link to={this.state.redirectTarget} onClick={this.handleClosePopUp} className='btn save-btn' style={{color: 'white'}}>TAK</Link>
										<button style={{marginLeft: '20px', color: 'rgb(223, 50, 50)'}} className='btn cancel-btn' id='rejectStart' onClick={this.handleClosePopUp}>NIE</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					</Draggable>
					{this.state.showOverlay === true ? <div id='v-overlay'></div> : null}
            	</span> : null} */}
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {userData: state.userData}
};

const AppProvider = connect(mapStateToProps)(withTranslation()(LeftMenu));

export default withRouter(AppProvider);
